"use strict";

(() => {
	class IM_TimelineWidget {
		/** @type {HTMLElement} */
		#$widget;

		/** @type {Swiper} */
		#swiper;

		constructor($widget) {
			this.#$widget = $widget;
		}

		initialize() {
			const updateOffsetAfter = function (swiper) {
				const lastSlide                 = swiper.slides[swiper.slides.length - 1];
				swiper.params.slidesOffsetAfter = (swiper.width - lastSlide.offsetWidth);
				swiper.updateSlides();
			};

			const $button_prev = this.#$widget.querySelector( '.elementor-swiper-button-prev' );
			const $button_next = this.#$widget.querySelector( '.elementor-swiper-button-next' );

			this.#swiper = new Swiper( this.#$widget, {
				slidesPerView: 'auto',
				navigation: {
					nextEl: $button_next,
					prevEl: $button_prev,
				},
				on: {
					init: updateOffsetAfter,
					resize: updateOffsetAfter
				}
			} );
		}
	}

	// Initialize widgets.
	const $widgets = document.querySelectorAll( '.im-timeline' );

	for ( const $widget of $widgets ) {
		$widget.timelineWidget = new IM_TimelineWidget( $widget );
		$widget.timelineWidget.initialize();
	}
})();
